import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router';
import './index.scss';
import { BASE_URL } from './common/constants';
import { AppProvider } from './context/AppContext';

// enable/diable devmode
Object.defineProperty(window, 'devmode', {
  set(value) {
    const boolValue = Boolean(value)

    localStorage.setItem('devMode', String(boolValue))

    console.info(`[devMode] set to ${boolValue}. Reloading…`)
    window.location.reload()
  },
  get() {
    return localStorage.getItem('devMode') === 'true'
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter basename={`/${BASE_URL}`}>
            <AppProvider>
                <App />
            </AppProvider>
        </BrowserRouter>
    </React.StrictMode>,
);
